import { useMemo } from "react";

import type { HotelForReOnboardingRequestQueryQuery } from "@/lib/gql/__generated__/graphql";

import * as FormModel from "@/components/features/dialog/re-onboarding-request/model";
import type * as FormModelType from "@/components/features/dialog/re-onboarding-request/model/type";

import * as UseCase from "../use-send-re-onboarding-request";
import * as Converter from "./converter";

type Props = {
	data: HotelForReOnboardingRequestQueryQuery;
};

export const useInitialized = ({ data }: Props) => {
	const initInputModel: FormModelType.ReOnboardingRequestFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter(data),
		[data],
	);

	const queryData: FormModelType.ReOnboardingRequestFormModel["QueryData"] = useMemo(() => data.hotel, [data]);

	const { inputModel, viewModel, onSetViewModel, onResetViewModel } =
		FormModel.useReOnboardingRequestFormModel(initInputModel);

	const { onSendReOnboardingRequest } = UseCase.useSendReOnboardingRequest(inputModel, onResetViewModel);

	return {
		queryData,
		viewModel,
		onSetViewModel,

		onSendReOnboardingRequest,
	};
};
